// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedGB from '../common/FormattedGB';
// css
import '../../styles/components/analytics/DataSourcesPieChartLegend.scss';


const DataSourcesPieChartLegend = ({ data, colors }) => {

  return (
    <div className='analytics-data-sources-pie-chart-legend'>
      <ul>
        {data.map((item, index) => (
          <li
            className={
              classnames({
                'analytics__data-sources-pie-chart-legend__item': true,
                'analytics__data-sources-pie-chart-legend__item--inactive': !item.active
              })
            }
            key={index}
          >
            <div
              style={{ backgroundColor: colors[index] }}
              className='analytics__data-sources-pie-chart-legend__color'
            />
            <div className='legend-text'>
              <div className='analytics__data-sources-pie-chart-legend__label'>
                {item.title}
              </div>
              <div className='analytics__data-sources-pie-chart-legend__value'>
                <FormattedGB value={item.value} perDay />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

DataSourcesPieChartLegend.propTypes = {
  data: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired
};

export default DataSourcesPieChartLegend;



// WEBPACK FOOTER //
// ./src/components/analytics/DataSourcesPieChartLegend.js